import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';

import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private httpClient: HttpClient) { }
  // static BASE_URL = "https://foyapi.topnotchsolutions.in/api/"
  static BASE_URL = "http://api.ecommerce.demo.topnotchsolutions.in/api/"
  static ADDUSER = "Account/Register"
  static GETOTP = "Account/RequestOTP"
  static VERIFYOTP = "Account/VerifyOTP"
  static LOGIN_WITH_OTP = "Account/LoginWithOTP"
  static IMAGELISTBYCODEANDTYPE = "ImageGallery/GetImageByCodeAndType"
  static CUSTOMERMENU = "Menu/GetAllCustomerMenu"
  static PRODUCTBYGENDERSUPPLIMENT = "Product/GetProductByGenderSuppliment"
  static TRENDINGPRODUCT = "Product/GetProductTrendingList"
  static GETCATEGORYSUBCATEGORYSKINTYPECONCERNBYCATEGORYID = "Category/Get_SubCategory_SkinType_Concern_ByCategoryId"
  static GETPRODUCTBYPARAMETERS = "customer/Product/GetProductByParameters"
  static GETPRODUCTBYTAGS = "customer/Product/GetProductFilterByTags"
  static UPDATEPRODUCTREVIEW = "ProductReview/LikeDisLikeProductReview"
  static GETALLBRAND = "Brand/GetAll"
  static GETBRANDBYSEARCHBRANDNAMEBYINITIALS = "Brand/SearchBrandNameByInitials"
  static SKINCONCERNLIST = "SkinConcernType/GetAllSkinConcern"
  static SKINTYPELIST = "SkinConcernType/GetAllSkinType"
  static USERPROFILE = "User/GetUserById"
  static ADDRESSLIST = "User/GetCustomerUserAddressList"
  static ADDADDRESS = "User/AddCustomerUserProfileAddress"
  static UPDATEADDRESS = "User/UpdateCustomerUserProfileAddress"
  static REMOVEADDRESS = "User/DeleteCustomerUserProfileAddress"
  static ORDERLIST = "Order/AdminGetAllOrder"
  static ORDERDETAIL = "Order/GetOrderDetailsByOrderId"
  static MANAGECARTBYUSER = "customer/ManageCart/ManageCartByUser"
  static GETWISHLISTBYUSER = "customer/ManageCart/GetWishListItemByUser"
  static GETCARTBYUSER = "customer/ManageCart/GetCartItemByUser"
  static UPDATE_PROFILE = "User/UpdateCustomerUserProfile"
  static BLOGLIST = "Blog/GetAllBlog"
  static BLOGLISTBYCATEGORYID = "Blog/GetBlogListByCategoryId"
  static GetAllBlogFilter = "Blog/GetAllBlogFilter"
  static GetBlogCataoryWiseWithAllFilter = "Blog/GetBlogCataoryWiseWithAllFilter"
  static CATEGORYBYTYPEID = "Category/GetCategoryByTypeId"
  static GETFOYALL = "FoyTV/GetAll"
  static ADDSUBSCRIBER = "NewsLetterSubscription/AddUpdate"
  static ADDPRODUCTCLICK = "Product/UpdateProductClickCount"
  static CONTACTUS = "customer/Customer/contactus"
  static PLACEORDER = "PlaceOrder/ExecuteOrder"
  static REMOVECARTBYUSER = "customer/ManageCart/ClearCartItemByUser"
  static SEARCHCUSTOMERPRODUCTSBRANDS = "customer/Customer/SearchProduct"
  static GETDISCOUNT = "Discount/GetDiscountByDiscount_Code"
  static GETAllDISCOUNT = "Discount/GetAllDiscount"
  static GETAllDISCOUNTCATELOGUE = "DiscountCateloge/GetAll"
  static GETAllDISCOUNTBYPRODUCTIDS = "Discount/GetDiscountFromProductId"
  static UPDATEORDERSTATUS = "Order/UpdateOrderStatus"
  static GETALLSUBCATEGORY = "SubCategory/GetAll"
  static GETALLCATEGORY = "Category/GetAll"
  static GETALLTAG = "Tag/GetAllTags"
  static GETHIGHLIGHTSRECOMMENDS = "Brand_Type_Mapping/GetAll"
  static GETGENDER = "Common/GetGender"
  static WEBSITECONFIGURATION = "websiteconfigurations/GetAll"
  static GETPRICELIST = "customer/Customer/priceList"
  static GETALLPRODUCTREVIEW = "ProductReview/GetAllProductReview"
  static ADDPRODUCTREVIEW = "ProductReview/AddProductReview"
  static UPDATEPRODUCTREVIEWPAGE = "ProductReview/UpdateProductReview"
  static GETPRODUCTREVIEWBYPRODUCTID = "ProductReview/GetProductReviewByProductId"
  static UPDATEPROFILE = "User/UpdateCustomerUserProfile"
  static LEAFCATEGORYLIST = "leaf_level_category/GetAllLeafCategory"
  /**
* API error handler. it will call when the status of API call is other than 200
*/
  static ErrorHandler = {
    handleError(operation: string) {
      return (err: any) => {
        const errMsg = `error in ${operation}() retrieving `;
        console.log(`${errMsg}:`, err);
        if (err instanceof HttpErrorResponse) {
          console.log(`status: ${err.status}, ${err.statusText}`);
        }
        return throwError(() => err);
      };

    }
  };
}

export class MCommonListModalRequest {
  "skip": any = 0
  "take": any = 20
  "search": string
  category_id: any;
  is_show_on_blog: any;
  categoryIds: any;
  brandIds: any;
  isAllowInactive: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MBlogFilterRequest {
  skip: any = 0
  take: any = 100
  catagoryid!: number;
  subcategoryid!: number;
  editors_pick: any;
  is_tranding: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}


export class MCommonBlogListModalRequest {
  "skip": any = 0
  "take": any = 20
  "catagoryid": any
  "subcategoryid": any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export const SharedPrefrences = {
  clearAllPrefrences() {
    localStorage.removeItem('foyuserId')
    localStorage.removeItem('foytoken')
    localStorage.removeItem('foyUserData')
  },
  setToken(token: string) {
    localStorage.setItem("foytoken", token)
  },
  getToken() {
    return localStorage.getItem("foytoken")
  },
  setUserId(userId: string) {
    localStorage.setItem("foyuserId", userId)
  },
  getUserId() {
    return localStorage.getItem("foyuserId")
  },
  setUserData(data: any) {
    localStorage.setItem("foyUserData", JSON.stringify(data))
  },
  getUserData() {
    return localStorage.getItem("foyUserData")
  },
  setCategoryId(categoryId: any) {
    localStorage.setItem("categoryId", categoryId)
  },
  getCategoryId() {
    return localStorage.getItem("categoryId")
  },
  setCustomerMenuList(data: string) {
    localStorage.setItem("customerMenuList", data)
  },
  getCustomerMenuList() {
    return localStorage.getItem("gustomerMenuList")
  },
  setBrandList(data: string) {
    localStorage.setItem("setBrandList", data)
  },
  getBrandList() {
    return localStorage.getItem("setBrandList")
  }
}

export class Services{
  private _event = new EventEmitter<any>();

  get orderListEvent(): EventEmitter<any> {
    return this._event;
  }
}
